import React, { Fragment } from "react";

let Styles: any;
try {
    Styles = require('./InputField_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch{

}

interface InputFieldProps {
  id: string,
  name: string,
  value: string,
  type: string,
  onBlur: any,
  onChange: any,
  onKeyDown?: any,
  onKeyUp?: any,
  onKeyPress?: any,
  placeholder : string,
  styleClass?: string,
  tabIndex?:number
}
const InputField: React.FC<InputFieldProps> = (props: InputFieldProps) => {
  const { styleClass, ...rest} = props;
  return (
    <Fragment>
        <input
          {...rest}
          className={Styles.inputText + " " + styleClass}
        />
    </Fragment>
  );
};

export default InputField;